import { useEffect, useRef, useState } from "react";

import * as Material from "@mui/material";

import ConfigLoader from "../../components/ConfigLoader";

import Popper from "@components/Popper";

import './styles.css'

import api from '@helpers/api'

import { AddRounded, AllInclusiveRounded, CachedRounded, CopyAllRounded, CreditCardRounded, DeleteRounded, MoreVertRounded, PixRounded, RedoRounded, RotateRightRounded, SettingsRounded } from "@mui/icons-material";

import { useCommunity } from "contexts/community";

import { useParams } from "react-router-dom";

import Parser from '@helpers/parser'
import ConfigPlanModal from "@components/_modals/Billing/ManagePlanModal";

import { Table, Button, Text } from "@fragments";

export default function Pricing({ info }) {
    const [loading, setLoading] = useState(true)

    let { slug } = useParams();

    const [plans, setPlans] = useState([])

    const { loading: communityLoading, community, loadCommunities } = useCommunity();

    const REF_config = useRef()
    const REF_configPlanModal = useRef()

    const popperRef = useRef()


    useEffect(() => {
        if (!communityLoading) handleLoad()
    }, [communityLoading])

    async function handleLoad() {
        setLoading(true)

        try {
            const currentCommunity = community.getBySlug(slug);
            if (currentCommunity?.id) {
                const { data } = await api.get(`community/${currentCommunity.id}/plan`)
                setPlans(data)
            }
        } catch (e) {
            console.log(e)
        }

        setLoading(false)
    }

    function handleConfigurePlan(id) {
        REF_configPlanModal.current.open({
            id,
            community: community.getBySlug(slug).id
        }, async function (result) {
            console.log(result)
            handleLoad()
            await loadCommunities()
        })
    }

    function handleDeletePlan(id) {
        window.openConfirm({
            title: "Deletar plano",
            headline: "Atenção!",
            subtitle: "Você realmente deseja apagar permanentemente este plano?",
            buttons: [
                {
                    text: "Apagar permanentemente",
                    onClick: handleExecuteDelete,
                    variant: "contained",
                    className: "",
                    color: "error",
                },
                {
                    text: "Manter plano",
                    variant: "text",
                },
            ],
        });

        async function handleExecuteDelete() {
            try {
                const data = await api.delete('community/plan/' + id)
                if (data.status === 204) {
                    window.setSnackbar('Plano deletado com sucesso')
                    await handleLoad()
                }
            } catch (e) {
                window.setSnackbar('Ocorreu um erro ao deletar o plano, verifique se você possui permissão para realizar esta ação')
                console.log(e)
            }
        }
    }

    function handleOpenPlanOptions(event, planId) {
        const options = [
            {
                id: 'configure',
                label: 'Configurar',
                icon: <SettingsRounded fontSize="small" />,
                onClick: async () => {
                    handleConfigurePlan(planId);
                    popperRef.current.close();
                }
            },
            {
                id: 'delete',
                label: 'Excluir plano',
                icon: <DeleteRounded fontSize="small" />,
                variant: 'danger',
                onClick: async () => {
                    handleDeletePlan(planId);
                    popperRef.current.close();
                }
            }
        ];

        popperRef.current.open(options, 'bottom', event.currentTarget);
    }

    function handleCopy(plan) {
        const link = `https://pay.ginastee.com/${community.getBySlug(slug).checkout}?plan=${plan}`
        navigator.clipboard.writeText(link).then(() => {
            window.setSnackbar("Link copiado");
        }).catch(err => {
            console.error('Erro ao copiar:', err);
            window.setSnackbar("Erro ao copiar o link");
        });
    }

    const columns = [
        {
            title: "Recorrência",
            minWidth: 120,
            customRender: (item) => (
                <span className="interval-badge plan-config-row" style={{ paddingRight: '11px' }}>
                    {
                        item.interval === 'lifetime' ? <AllInclusiveRounded fontSize="small" /> : !item.autorenew ? <CachedRounded fontSize="small" /> : <RedoRounded fontSize="small" />
                    }
                    <small>{Parser.interval.adjective(item.interval)}</small>
                </span>
            )
        },
        {
            field: "label",
            title: "Plano",
            grow: 1,
            render: (item) => item.label
        },
        {
            title: "Preço",
            grow: 1,
            customRender: (item) => (
                <Text.span contrast={6}>
                    R${Parser.price.brl(item.price)} {item.installments > 1 && `ou ${item.installments}x de R$${Parser.price.brl(item.installments_list[item.installments - 1] / item.installments)}`}
                </Text.span>
            )
        },
        {
            title: "Métodos",
            minWidth: 150,
            customRender: (item) => (
                <div className="plan-config-row methods-row">
                    <div className={"plan-config-row method " + (!item.methods.credit.enabled && 'disabled')}>
                        <CreditCardRounded fontSize="small" />
                        <small>Crédito</small>
                    </div>
                    <Material.Divider flexItem orientation="vertical" />
                    <div className={"plan-config-row method " + (!item.methods.pix.enabled && 'disabled')}>
                        <PixRounded fontSize="small" />
                        <small>PIX</small>
                    </div>
                </div>
            )
        }
    ];


    function CreatePlanButton() {
        return (
            <Button
                onClick={() => handleConfigurePlan()}
                endIcon={< AddRounded />}
                text="Criar plano"
            />
        )
    }


    return (
        <div className="config-page config-general-community config-plans-page" key={loading}>
            { (
                <div className="mt-4" key={Math.random()}>

                    <div className="px-3 mt-4">
                        <Text.h3
                            grow
                            left={<RotateRightRounded />}
                            right={<CreatePlanButton />}
                            value="Planos configurados"
                            className="mb-2"
                        />
                    </div>

                    <Table
                        id="community-pricing-table"
                        columns={columns}
                        data={plans}
                        loading={loading}
                        fullWidth
                        actionsComponent={(item) => (
                            <div className="plan-config-row" style={{ gap: '8px', justifyContent: 'flex-end', width: '100%' }}>
                                <span className="plan-row-btn"
                                    onClick={() => handleCopy(item.id)}
                                    title="Link do checkout"
                                >
                                    <CopyAllRounded fontSize="small" />
                                </span>
                                <span
                                    className="plan-row-btn"
                                    onClick={() => handleConfigurePlan(item.id)}
                                    title="Configurar"
                                >
                                    <SettingsRounded fontSize="small" />
                                </span>
                                <span
                                    className="plan-row-btn"
                                    onClick={(event) => handleOpenPlanOptions(event, item.id)}
                                    title="Mais opções"
                                >
                                    <MoreVertRounded fontSize="small" />
                                </span>
                            </div>
                        )}
                    />
                </div>
            )}

            <Popper controlRef={popperRef} />

            <ConfigPlanModal modalRef={REF_configPlanModal} />
        </div >
    )
}
